document.addEventListener("DOMContentLoaded", function () {
  loadProducts();
});
function loadProducts() {
  let loadingBtn = document.querySelector("#loading_next .button");

  if (loadingBtn) {
    if (loadingBtn.dataset.infiniteBound === "true") return;
    loadingBtn.dataset.infiniteBound = "true";

    const setLoadingState = (isLoading) => {
      if (!loadingBtn) return;
      loadingBtn.classList.toggle("loading-products", isLoading);
      const spinner = loadingBtn.querySelector(".loading-overlay__spinner");
      if (spinner) spinner.classList.toggle("hidden", !isLoading);
    };

    loadingBtn.addEventListener("click", function (event) {
      event.preventDefault();
      const productsPerPage = parseInt(
        document.querySelector("[data-products-per-page]")?.value || "40",
        10
      );
      const totalPages = parseInt(
        document.querySelector("[data-total-pages]")?.value || "1",
        10
      );
      let currentPage = parseInt(
        document.querySelector("[data-current-page]")?.value || "1",
        10
      );
      const nextUrlSelector = document.querySelector("[data-next-url]");
      const productCountWrapper = document.querySelector(
        ".products-count__wrapper[data-products-count-text]"
      );
      const productCountTarget = productCountWrapper?.querySelector(
        "span[data-products-count-text], span"
      );

      if (!nextUrlSelector || currentPage >= totalPages) return;

      setLoadingState(true);
      currentPage += 1;

      let nextUrl = nextUrlSelector.value || "";
      if (/page=[0-9]+/.test(nextUrl)) {
        nextUrl = nextUrl.replace(/page=[0-9]+/, "page=" + currentPage);
      } else if (nextUrl.includes("?")) {
        nextUrl = `${nextUrl}&page=${currentPage}`;
      } else {
        nextUrl = `${nextUrl}?page=${currentPage}`;
      }

      nextUrlSelector.value = nextUrl;
      const currentPageInput = document.querySelector("[data-current-page]");
      if (currentPageInput) currentPageInput.value = currentPage;

      fetch(nextUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const parsed = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const nextGrid = parsed.getElementById("product-grid");
          const currentGrid = document.querySelector("#product-grid");
          const lastItemBefore = currentGrid?.lastElementChild;
          if (currentGrid && nextGrid) {
            currentGrid.insertAdjacentHTML("beforeend", nextGrid.innerHTML);
          }

          if (productCountWrapper && productCountTarget) {
            const nOfProducts = document.querySelectorAll(
              "#product-grid li:not(.grid__item--content-tile):not(.grid__item--full-width-banner)"
            ).length;
            const productCountsText = {
              "{{total_products}}": productCountWrapper.dataset.totalProducts,
              "{{current_products}}": nOfProducts,
            };
            productCountTarget.innerHTML =
              productCountWrapper.dataset.productsCountText.replace(
                /{{total_products}}|{{current_products}}/gi,
                function (matched) {
                  return productCountsText[matched];
                }
              );
          }

          if (currentPage === totalPages) {
            // Hiding the focused button would drop keyboard focus, so move it to the first new product.
            if (loadingBtn.matches(":focus-visible")) {
              const firstNewItem = lastItemBefore ? lastItemBefore.nextElementSibling : currentGrid?.firstElementChild;
              firstNewItem?.querySelector("a[href]")?.focus({ preventScroll: true });
            }
            loadingBtn.style.display = "none";
          }
          document.dispatchEvent(new CustomEvent("theme:loading:end"));
          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          setLoadingState(false);
        });
    });
  }
}
